import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import Gift from "./icons/Gift";
import Button from "shared/ui/Button";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import { BuyGiftApi } from "../api";
import { useParams } from "react-router-dom";
import { userSelect } from "shared/redux/selectors/user";
import { showError } from "shared/lib/showError";
import { renderWord } from "../lib/renderWord";
import Activate from "../Activate";
import { MallSelect } from "entities/MallSelect";
import { mallSelect } from "shared/redux/selectors/mall";
import { IMallItem } from "shared/types/malls";
import { BuyGiftDTO } from "../api/models";

interface BuyConfirmProps {
  price: number;
  onSuccess: (id: number, activated: boolean) => void;
  id: number;
  text: string;
  malls?: IMallItem[];
}

const BuyConfirm: React.FC<BuyConfirmProps> = ({
  price,
  onSuccess,
  id,
  text,
  malls,
}) => {
  const { auth_key, user_info } = useAppSelector(userSelect);
  const mall = useAppSelector(mallSelect);
  const dispatch = useAppDispatch();

  const [activeMall, setActiveMall] = useState<IMallItem>();
  const [dataSending, setDataSending] = useState(false);

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    dispatch(setOpen(false));
    dispatch(setContent(null));
  };

  const handleActivateModalOpen = () => {
    dispatch(setOpen(true));
    dispatch(
      setContent(
        <Activate id={id} text={text} onSuccess={onSuccess} price={price} />
      )
    );
  };

  const handleSubmit = () => {
    if (user_info && auth_key && id) {
      setDataSending(true);

      const dto: BuyGiftDTO = {
        auth_key,
        id: id,
        user_id: user_info.id,
      };

      if (activeMall) dto.mall_id = activeMall.id;

      BuyGiftApi(dto)
        .then((res) => {
          const activated = res.activated === 1;

          onSuccess(res.id, activated);

          if (!activated) handleActivateModalOpen();
        })
        .catch((e) => showError(e, dispatch))
        .finally(() => setDataSending(false));
    }
  };

  useEffect(() => {
    if (malls && malls.length >= 1) setActiveMall(malls[0]);
  }, [malls]);

  return (
    <div className={s.confirm}>
      <div className={s.icon}>
        <Gift />
      </div>

      <p className={s.text}>
        С Вашего бонусного счета будет списано{" "}
        <span>
          {price} {renderWord(price)}
        </span>
      </p>

      {malls && malls.length > 1 && (
        <div className={s.select}>
          <span className={s.label}>Выберите РЦ для получения:</span>
          <MallSelect
            malls={malls}
            setValue={setActiveMall}
            value={activeMall}
          />
        </div>
      )}

      <Button
        disabled={dataSending}
        onClick={handleSubmit}
        className={s.accept}
      >
        Подтвердить
      </Button>

      <button className={s.cancel} onClick={handleCancel}>
        Отмена
      </button>
    </div>
  );
};

export default BuyConfirm;
